// 设置登录用户
export const SET_LOGINED_USER = 'SET_LOGINED_USER'
// 设置页面加载状态
export const SET_LOADING = 'SET_LOADING'

// 设置登录TOKEN
export const SET_TOKEN = 'SET_TOKEN'

export const SET_INDEX_NAME= 'SET_INDEX_NAME'
export const SET_INDEX_CODE = 'SET_INDEX_CODE'
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS'
export const SET_DIMENSIONS = 'SET_DIMENSIONS'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js